import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	AGEDEMOGRAPHIC_REQUEST,
	AGEDEMOGRAPHIC_CREATE,
	AGEDEMOGRAPHIC_DELETE,
	AGEDEMOGRAPHIC_EDIT,
	AGEDEMOGRAPHIC_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { ToastContainer, toast } from 'react-toastify';

const AgeDemographic = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchAgeDemographic,
	submitAgeDemographicCreate,
	submitAgeDemographicDelete,
	submitAgeDemographicEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteAgeDemographicId, setDeleteAgeDemographicId] = useState('');
	const [editAgeDemographicId, setEditAgeDemographicId] = useState('');
	const [editAgeDemographicName, setEditAgeDemographicName] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchAgeDemographic(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("Age Demographic Created Successfully.");
			fetchAgeDemographic(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("Age Demographic Deleted Successfully.");
			fetchAgeDemographic(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("Age Demographic Data Updated Successfully.");
			fetchAgeDemographic(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create age demographic create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("Age Demographic name cannot be empty.");
		} else {
			submitAgeDemographicCreate({
				"data": {
					"AgeDemographics": inputVal,
					"AgeDemographicsOrder": 1,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteAgeDemographicId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteAgeDemographicId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete age demographic delete api
	const handleConfirmDeleteSubmit = () => {
		submitAgeDemographicDelete({
			"ageDemographicsId": deleteAgeDemographicId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditAgeDemographicId(data.ageDemographicsId);
		setEditAgeDemographicName(data.ageDemographics);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editAgeDemographicName === '') {
			toast.error("Age Demographic name cannot be empty.");
		} else {
			submitAgeDemographicEdit({
				"data": {
					"AgeDemographicsId": data.ageDemographicsId,
					"AgeDemographics": editAgeDemographicName,
					"AgeDemographicsOrder": data.ageDemographicsOrder
				},
				"token": auth[0].token
			});
			setEditAgeDemographicId('');
			setEditAgeDemographicName('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">
					<ToastContainer />
					<div className="sub-header mt-5 mb-3">
						<h2>Age Demographic</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`Age Demographic`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>Age Demographic</th>
								<th width="50">Delete</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editAgeDemographicId === item.ageDemographicsId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editAgeDemographicName} onChange={(evt) => setEditAgeDemographicName(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.ageDemographics}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`Age Demographic`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.ageDemographicsId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	);
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchAgeDemographic: (token) => dispatch({ type: AGEDEMOGRAPHIC_REQUEST, token }),
		submitAgeDemographicCreate: (data) => dispatch({ type: AGEDEMOGRAPHIC_CREATE, payload: data }),
		submitAgeDemographicDelete: (data) => dispatch({ type: AGEDEMOGRAPHIC_DELETE, payload: data }),
		submitAgeDemographicEdit: (data) => dispatch({ type: AGEDEMOGRAPHIC_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: AGEDEMOGRAPHIC_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(AgeDemographic);